import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import CookieBanner from "./components/feature/CookieBanner";
import ScrollToTopButton from "./components/feature/ScrollToTopButton";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
      <CookieBanner />
      <ScrollToTopButton />
    </BrowserRouter>
  );
}

export default App;